import { WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const hasCorrection = useSelector(createWorksheetSelector!('EnterFieldRockCorrection'));
  const correctionNotRequired = useSelector(
    pipe(
      createWorksheetSelector!('OversizeCorrectionTest.MeasuredTest.OversizeCorrectionNotRequired'),
      valueOrDefault(false)
    )
  );
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field input={<TextOutput />} name="Results.MaximumDryDensity" />
        <Field input={<TextOutput />} name="Results.OptimumMoistureContent" />
        {hasCorrection && (
          <>
            <Field
              input={<TextOutput />}
              name="OversizeCorrectionTest.MeasuredTest.Results.CorrectedMaximumDryDensity"
              label="Corrected Maximum Dry Density"
              blankReplacement={correctionNotRequired ? 'N/A' : undefined}
            />
            <Field
              input={<TextOutput />}
              name="OversizeCorrectionTest.MeasuredTest.Results.CorrectedOptimumMoistureContent"
              label="Corrected Optimum Moisture Content (%)"
              blankReplacement={correctionNotRequired ? 'N/A' : undefined}
            />
          </>
        )}
        <Field input={<TextOutput />} name="Results.InsituWetDensity" label="In-situ Wet Density" />
        <Field input={<TextOutput />} name="Results.InsituMoistureContent" label="In-situ Moisture Content (%)" />
        <Field input={<TextOutput />} name="Results.InsituDryDensity" label="In-situ Dry Density" />
        <Field input={<TextOutput />} name="Results.RelativeCompaction" />
        <Field input={<TextOutput />} name="Results.MoistureVariation" />
      </ListFieldSection>
    </>
  );
};

const ArizResultsSection = withInjectedProps(Section);

export { ArizResultsSection };
export default ArizResultsSection;
